/* global $ */

export function fetchPlace(url) {
  return new Promise((resolve, reject) => {
    $.get(url, data => resolve(data), 'json').fail((xhr, textStatus, errorThrown) => {
      reject(
        new Error(`Places search request failed: ${textStatus}${errorThrown ? ` (${errorThrown})` : ''}`)
      );
    });
  });
}
